import { useState } from "react";
import { Download, RotateCcw } from "lucide-react";
import { buildPlan, concernLabels } from "@/lib/journeyEngine";
import { downloadPlan } from "@/lib/planPdf";

export const PlanDownload = ({ journey, answers, onRestart }) => {
  const [includeConcerns, setIncludeConcerns] = useState(false);
  const download = () => {
    const plan = buildPlan(journey, answers, { neutral: true });
    downloadPlan(plan, { concerns: includeConcerns ? concernLabels(journey, answers) : [] });
  };
  return (
    <section className="rounded-[2rem] bg-sage-light p-6 sm:p-8" aria-labelledby="plan-heading" data-testid="journey-plan-section">
      <h2 id="plan-heading" className="text-2xl sm:text-3xl">Would you like to take your next steps with you?</h2>
      <p className="mt-3 text-ink-soft">Your plan is created on this device. Nothing you've chosen is sent to us or saved.</p>
      <label className="mt-5 flex items-start gap-3 cursor-pointer">
        <input type="checkbox" checked={includeConcerns} onChange={(e) => setIncludeConcerns(e.target.checked)} className="mt-1 h-5 w-5 accent-[#2F6B6A] shrink-0" data-testid="journey-include-concerns-checkbox" />
        <span>Include what I chose in the questions <span className="block text-sm text-ink-muted">Safety and relationship answers are never included. Leave this unticked if others might see the file.</span></span>
      </label>
      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        <button type="button" onClick={download} className="btn-primary" data-testid="journey-download-plan-button"><Download className="h-5 w-5" aria-hidden="true" />Download my plan (PDF)</button>
        <button type="button" onClick={onRestart} className="btn-secondary" data-testid="journey-restart-button"><RotateCcw className="h-5 w-5" aria-hidden="true" />Start again and clear my answers</button>
      </div>
      <p className="mt-4 text-sm text-ink-muted">A downloaded file stays on this device. On a shared phone or computer, you may want to delete it afterwards.</p>
    </section>
  );
};
